<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
      <div class="modal-header">
        Nom du dossier
      </div>
      <div class="modal-body">
        <form (ngSubmit)="validFolderName()">
          <frg-form-input
            label="Nom du dossier"
            id="folderName"
            type="text"
            [formGroup]="formGroup"
            [control]="formGroup.get('folderName')"
          ></frg-form-input>
        </form>
        <div class="button-wrapper" *ngIf="formGroup">
          <frg-button backgroundColor="var(--darkest-primary)" (activated)="closeModal()">Annuler</frg-button>
          <frg-button backgroundColor="var(--primary)" (activated)="validFolderName()" [disabled]="!formGroup.valid">{{ validButtonLabel }}</frg-button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-background"></div>